import React, { Component } from 'react';
import Field from 'redux-form/lib/Field';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import Alert from 'react-bootstrap/lib/Alert';
import Button from 'react-bootstrap/lib/Button';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import { Link } from 'react-router-dom';
import FieldFormGroup from '../FieldFormGroup';
import OutboundLink from '../OutboundLink';
import FacebookIcon from '../FacebookIcon';
import GoogleIcon from '../GoogleIcon';
import TwitterIcon from '../TwitterIcon';
import styles from './styles.sass';
import onboardingStyles from '../OnboardingRouter/styles.sass';

class Login extends Component {
  handleClickRequestResetPassword = evt => {
    const { clickRequestResetPassword } = this.props;
    evt.preventDefault();
    clickRequestResetPassword();
  };

  render() {
    const {
      error,
      handleSubmit,
      submitting,
      showHelpLinks = true,
      feedUrl,
    } = this.props;
    const feedUrlQuery = feedUrl
      ? `?feedUrl=${encodeURIComponent(feedUrl)}`
      : '';
    const signupUrl = `/signup${feedUrlQuery}`;
    const authTwitterUrl = `/auth/twitter${feedUrlQuery}`;
    const authFacebookUrl = `/login/facebook${feedUrlQuery}`;
    const authGoogleUrl = `/login/google${feedUrlQuery}`;
    // TODO: better handle errors
    let errorString = '';
    if (error) {
      try {
        const errorObj = JSON.parse(error);
        if (errorObj.status === 401) {
          errorString = 'Invalid username or password.';
        } else {
          errorString = 'Unable to log in at this time.';
        }
      } catch (err) {
        errorString = error;
      }
    }
    return (
      <div className={styles.loginForm}>
        <form onSubmit={handleSubmit} id="form1">
          {errorString && <Alert bsStyle="danger">{errorString}</Alert>}
          <div>
            <Field
              name="email"
              placeholder="Email"
              component={FieldFormGroup}
              type="email"
            />
            <Field
              name="password"
              placeholder="Password"
              component={FieldFormGroup}
              type="password"
            />
          </div>
          <FormGroup>
            <Button
              bsClass={`${onboardingStyles.nextButton} ${
                onboardingStyles.fullWidth
              } ${onboardingStyles.loginButton}`}
              bsStyle="primary"
              block
              type="submit"
              disabled={submitting}
            >
              Log in
            </Button>
            <div className={onboardingStyles.terms}>
              By continuing, you agree to our{' '}
              <a href="/tos">Terms of Service</a> and{' '}
              <a href="/privacy">Privacy Policy</a>.
            </div>
          </FormGroup>
        </form>
        <Row>
          <Col sm={4} className={styles.socialLogin}>
            <OutboundLink to={authFacebookUrl} style={{ color: '#39579B' }}>
              <FacebookIcon width={24} height={24} /> Facebook
            </OutboundLink>
          </Col>
          <Col sm={4} className={styles.socialLogin}>
            <OutboundLink to={authGoogleUrl} style={{ color: '#8c8c8c' }}>
              <GoogleIcon width={18} height={18} /> Google
            </OutboundLink>
          </Col>
          <Col sm={4} className={styles.socialLogin}>
            <OutboundLink to={authTwitterUrl} style={{ color: '#50ABF1' }}>
              <TwitterIcon width={25} height={20} /> Twitter
            </OutboundLink>
          </Col>
        </Row>
        {showHelpLinks && (
          <Row>
            <Col sm={12} className={styles.loginFooter}>
              <p style={{ marginBottom: '12px' }}>
                Don't have an account? <Link to={signupUrl}>Sign up</Link>{' '}
                instead.
              </p>
              <p className="text-center">
                <a onClick={this.handleClickRequestResetPassword}>
                  Forgot password?
                </a>
              </p>
            </Col>
          </Row>
        )}
      </div>
    );
  }
}

export default Login;
